export default __webpack_public_path__ + "static/media/logo.e17366f7.png";